import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";

import { partiallyMatchedEmployeeSelector } from "../common/selectors";
import {
    matchFastTrackPitPupMedicalFormToNewEmployeeRecord,
    matchFastTrackPitPupMedicalFormToEmployeeRecord,
    rerunPartiallyMatchedFastTrackPitPupMedicalFormDetail,
    loadPartiallyMatchedFastTrackPitPupMedicalFormDetail
} from "../fastTrackPitPupMedicalForms/actions";
import { PartiallyMatchedEmployeeAppState } from "../common/model";
import {
    MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_EMPLOYEE_RECORD,
    MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_NEW_EMPLOYEE_RECORD,
    RERUN_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL
} from "../fastTrackPitPupMedicalForms/actionTypes";

import { Detail, DetailDispatchProps, DetailProps } from "./Detail";

function mapStateToProps(state: PartiallyMatchedEmployeeAppState): DetailProps {
    return {
        partiallyMatchedEmployee: partiallyMatchedEmployeeSelector(state),
        title: "Fast Track PIT/PUP Medical Form",
        moreRoute: "",
        isSubmitting: isRequestActive(state, MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_EMPLOYEE_RECORD)
            || isRequestActive(state, MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_NEW_EMPLOYEE_RECORD)
            || isRequestActive(state, RERUN_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL),
        referralId: state.router.params.referralId,
        customerId: state.router.params.customerId
    };
}

function mapDispatchToProps(dispatch: any): DetailDispatchProps {
    return {
        matchEmployeeToNewEmployeeRecord: (customerId: string, fastTrackPitPupMedicalFormId: string) =>
            dispatch(matchFastTrackPitPupMedicalFormToNewEmployeeRecord(customerId, fastTrackPitPupMedicalFormId)),
        matchToEmployeeRecord: (formCustomerId: string, fastTrackPitPupMedicalFormId: string, employeeRecordCustomerId: string, employeeRecordId: string) =>
            dispatch(matchFastTrackPitPupMedicalFormToEmployeeRecord(formCustomerId, fastTrackPitPupMedicalFormId, employeeRecordCustomerId, employeeRecordId)),
        rerunEmployeeMatching: (customerId: string, fastTrackPitPupMedicalFormId: string) =>
            dispatch(rerunPartiallyMatchedFastTrackPitPupMedicalFormDetail(customerId, fastTrackPitPupMedicalFormId)),
        loadPartiallyMatchedDetails: (customerId: string, referralId: string) =>
            dispatch(loadPartiallyMatchedFastTrackPitPupMedicalFormDetail({ customerId, referralId }))
    };
}

export const FastTrackPitPupMedicalFormDetail = connect(mapStateToProps, mapDispatchToProps)(Detail);
